import { render } from "./RoutePlace.vue?vue&type=template&id=52912502&scoped=true"
import script from "./RoutePlace.vue?vue&type=script&lang=ts"
export * from "./RoutePlace.vue?vue&type=script&lang=ts"

import "./RoutePlace.vue?vue&type=style&index=0&id=52912502&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52912502"

export default script